//
// TLS Dose Engine Slurm Cluster page
//
import { useState, useEffect } from "react";

import gSession from '../script/session.js';
import gUtilities from '../script/utilities';

import TableWidget from './TableWidget';

const ClusterPage = () => {
    const [sinfo, setSInfo] = useState(null);
    const [squeue, setSQueue] = useState(null);

    function fill(text, table) {
        let lines = text.split('\n');
        let tokens;
        let index;
        let row;

        for (let line of lines) {
            if (line.indexOf(table.titles[0]) !== -1) {
                continue;
            }

            row = {};
            tokens = line.split(' ');

            index = 0;
            for (let token of tokens) {
                if (token.length > 0) {
                    row[table.columns[index]] = token;
                    index++;
                }
            }

            if (index > 0) {
                table.data.push(row);
            }
        }
    }

    function toSInfoTable(text) {
        let sinfo = {
            columns: ["partition", "avail", "timelimit", "nodes", "state", "nodelist"],
            titles: ["PARTITION", "AVAIL", "TIMELIMIT", "NODES", "STATE", "NODELIST"],
            data: [],
        };

        fill(text, sinfo);

        // move idle~ entries to the bottom
        sinfo.data.sort((l, r) => {
            if (l.state === r.state) {
                return 0;
            }

            if (l.state === "idle~") {
                return 1;
            }

            return -1;
        });

        return sinfo;
    }

    function toSQueueTable(text) {
        let squeue = {
            columns: ["jobid", "partition", "name", "user", "st", "time", "nodes", "nodelist"],
            titles: ["JOBID", "PARTITION", "NAME", "USER", "ST", "TIME", "NODES", "NODELIST"],
            data: [],
        };

        fill(text, squeue);

        return squeue;
    }

    function isQueueDown(row) {
        return row.state.indexOf("down") !== -1;
    }

    function isQueueIdle(row) {
        return row.state === "idle";
    }

    function isQueueAllocated(row) {
        return row.state === "alloc";
    }

    function isQueueBooting(row) {
        return row.state === "alloc#";
    }

    function isJobOpenMC(row) {
        return row.name.indexOf("OMC") === 0;
    }

    function isJobReservation(row) {
        return row.name.indexOf("RSV") === 0;
    }

    function isJobPlotting(row) {
        return row.name.indexOf("PLT") === 0;
    }

    async function getSInfo() {
        let request = {
            command: "slurm.sinfo"
        };

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("SInfo", response.message);
        } else {
            let data = toSInfoTable(response.text);
            setSInfo(data)
        }
    }

    async function getSQueue() {
        let request = {
            command: "slurm.squeue"
        };

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("SQueue", response.message);
        } else {
            let data = toSQueueTable(response.text);
            setSQueue(data)
        }
    }

    function sInfoRowClass(row) {
        if (row && isQueueDown(row)) {
            return "table-danger";
        } else if (row && isQueueAllocated(row)) {
            return "table-success";
        } else if (row && isQueueIdle(row)) {
            return "table-info";
        } else if (row && isQueueBooting(row)) {
            return "table-warning";
        } else {
            return "table-light";
        }
    };

    function sQueueRowClass(row) {
        if (row && isJobOpenMC(row)) {
            return "table-success";
        } else if (row && isJobReservation(row)) {
            return "table-warning";
        } else if (row && isJobPlotting(row)) {
            return "table-info";
        } else {
            return "table-light";
        }
    };

    function scheduleUpdate() {
        let id = setTimeout(async () => {
            try {
                await getSQueue();
                await getSInfo();
            } catch (ex) {
                console.log("ERROR: [EXCEPTION] Slurm data - ", ex);
            }
        }, 1000);

        return id;
    }

    useEffect(() => {
        let timer_id = scheduleUpdate();

        // cleanup function: stop updates.
        return () => {
            clearTimeout(timer_id);
        };
    }, [sinfo]);

    return (
        <div id="w_ClusterPageRootDiv">
            <div>
                <h2>SQueue</h2>
                {squeue &&
                    <TableWidget name="squeue" data={squeue.data} columns={squeue.columns} titles={squeue.titles} rowClassFunction={sQueueRowClass} />
                }
            </div>
            <br></br>
            <h2>SInfo</h2>
            <div>
                {sinfo &&
                    <TableWidget name="sinfo" data={sinfo.data} columns={sinfo.columns} titles={sinfo.titles} rowClassFunction={sInfoRowClass} />
                }
            </div>
        </div>
    );
}

export default ClusterPage;